import { defu } from "defu";
import { reactivePick } from "@vueuse/core";
import { encode } from "uqr";
import { ref, computed, defineComponent, h, watchEffect, useRuntimeConfig } from "#imports";
import { renderSVGBody } from "#qrcode/utils/qrcode/svg/render";
import { getSize } from "#qrcode/utils/qrcode/svg/utils";
export default defineComponent({
  name: "Qrcode",
  props: {
    value: {
      type: String,
      required: true
    },
    variant: {
      type: [String, Object]
    },
    radius: {
      type: Number
    },
    pixelPadding: {
      type: Number
    },
    blackColor: {
      type: String
    },
    whiteColor: {
      type: String
    },
    boostEcc: {
      type: Boolean
    },
    border: {
      type: Number
    },
    ecc: {
      type: String
    },
    invert: {
      type: Boolean
    },
    maskPattern: {
      type: Number
    },
    maxVersion: {
      type: Number
    },
    minVersion: {
      type: Number
    },
    onEncoded: {
      type: Function
    },
    pixelSize: {
      type: Number
    }
  },
  setup(props, { attrs }) {
    const qr = ref();
    const _options = reactivePick(props, (_, key) => key !== "value");
    const options = computed(() => {
      return defu(
        _options,
        useRuntimeConfig().public.qrcode.options
      );
    });
    watchEffect(() => {
      const {
        value,
        radius,
        pixelSize,
        pixelPadding,
        variant,
        // SVGAttrs
        width,
        height,
        preserveAspectRatio,
        // render body
        whiteColor,
        blackColor,
        invert,
        // encode options
        ...opts
      } = options.value;
      const result = encode(props.value, opts);
      const s = getSize(result.size, pixelSize);
      qr.value = h("svg", {
        ...attrs,
        width,
        height,
        preserveAspectRatio,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: `0 0 ${s.width} ${s.height}`,
        innerHTML: renderSVGBody(
          result,
          {
            radius,
            pixelSize,
            pixelPadding,
            variant,
            border: opts.border,
            whiteColor,
            blackColor,
            invert
          }
        )
      });
    });
    return () => qr.value;
  }
});
